/**
 * @generated SignedSource<<fcb059e74382aa7ead5b12288490d406>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoSubjectExcludeRoot_TodoSubject$data = {
  readonly allBreadcrumbs: ReadonlyArray<{
    readonly isRoot: boolean | null;
    readonly requiredToDescribeTodo: boolean | null;
    readonly title: string;
  }>;
  readonly " $fragmentType": "TodoSubjectExcludeRoot_TodoSubject";
};
export type TodoSubjectExcludeRoot_TodoSubject$key = {
  readonly " $data"?: TodoSubjectExcludeRoot_TodoSubject$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoSubjectExcludeRoot_TodoSubject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoSubjectExcludeRoot_TodoSubject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubjectBreadcrumb",
      "kind": "LinkedField",
      "name": "allBreadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRoot",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredToDescribeTodo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoSubject",
  "abstractKey": null
};

(node as any).hash = "bc4ed2b252581c03d4075e1e6ab31db1";

export default node;
